module.exports = __webpack_public_path__ + "img/材料力学5_2.392aa5d5.jpg";